// app/components/PluginTabs.tsx
'use client'

import React, { useState } from 'react'
import styles from './PluginTabs.module.css'
import BotMonitor from './Plugins/Bots/BotMonitor'
import ConnectorsPanel from './Connectors/ConnectorsPanel'
// import ConnectorsPanel from './Connectors/ConnectorList';
import NostrRelay from './Plugins/NostrRelay/NostrRelay'
import QueryProvider from './Connectors/providers/QueryProvider'

// Add these imports at the top
import { Presence } from './Plugins/Presence/Presence'
import { Layouts } from './Plugins/Layouts/Layouts'
import Posts from './Plugins/Posts/Posts'
import Baskets from './Plugins/Baskets/Baskets'

const TABS = ['Plugins', 'Chat', 'Posts', 'Bots', 'Connectors'] // 'NIN Tokens' is not ready yet
// const TABS = ['Plugins', 'Chat', 'Posts', 'NIN Tokens', 'Bots', 'Connectors']

export default function PluginTabs() {
  const [activeTab, setActiveTab] = useState<string>(TABS[4])

  // Render the content for the active tab
  const renderTabContent = () => {
    switch (activeTab) {
      // Replace the Presence and Layouts buttons in the Plugins case with:
      case 'Plugins':
        return (
          <div className={styles.pluginContent}>
            {/* <p>Load plugins here (mock for now)...</p> */}
            {/* New Backtester Button */}
            <button
              onClick={() =>
                // Dispatch a custom event to open the backtester drawer
                window.dispatchEvent(new Event('open-backtester-drawer'))
              }
              className={styles.pluginButton}
              data-tutorial="backtester-button"
            >
              Backtester
            </button>

            <button
              onClick={() =>
                // Dispatch a custom event to open the backtester drawer
                window.dispatchEvent(new Event('open-optionsbuilder-drawer'))
              }
              className={styles.pluginButton}
            >
              Options Builder
            </button>

            <button
              onClick={() =>
                // Dispatch a custom event to open the backtester drawer
                window.dispatchEvent(new Event('open-events-drawer'))
              }
              className={styles.pluginButton}
            >
              Events
            </button>

            <button
              onClick={() =>
                // Dispatch a custom event to open the backtester drawer
                window.dispatchEvent(new Event('open-sentiment-drawer'))
              }
              className={styles.pluginButton}
            >
              Sentiment
            </button>

            <button
              onClick={() =>
                // Dispatch a custom event to open the backtester drawer
                window.dispatchEvent(new Event('open-hedging-drawer'))
              }
              className={styles.pluginButton}
            >
              Hedging
            </button>

            <button
              onClick={() =>
                // Dispatch a custom event to open the historicals drawer
                window.dispatchEvent(new Event('open-historicals-drawer'))
              }
              className={styles.pluginButton}
            >
              Historicals
            </button>

            {/* New AI HedgeFund Button */}
            <button
              onClick={() =>
                // Dispatch a custom event to open the AI HedgeFund drawer (adjust event name as needed)
                window.dispatchEvent(new Event('open-aihedgefund-drawer'))
              }
              className={styles.pluginButton}
            >
              AI HedgeFund
            </button>

            {/* New Automations Button */}
            <button
              onClick={() =>
                // Dispatch a custom event to open the Automations modal
                window.dispatchEvent(new Event('open-automations-modal'))
              }
              className={styles.pluginButton}
            >
              Automations
            </button>

            {/* New Baskets Button */}
            <button
              onClick={() =>
                // Dispatch a custom event to open the Baskets drawer
                window.dispatchEvent(new Event('open-baskets-drawer'))
              }
              className={styles.pluginButton}
            >
              Baskets
            </button>

            {/* Presence and Layouts plugin buttons: */}
            <Presence />
            <Layouts />
          </div>
        )
      case 'Chat':
        return (
          <div>
            <NostrRelay />
          </div>
        )
      case 'Posts':
        return (
          <div>
            <Posts />
          </div>
        )
      case 'NIN Tokens':
        return <div>Token earnings history data goes here...</div>
      case 'Bots':
        return (
          <div>
            <BotMonitor />
          </div>
        )
      case 'Connectors':
        return (
          <div>
            <QueryProvider>
            <ConnectorsPanel />
            </QueryProvider>
          </div>
        )
      default:
        return null
    }
  }

  return (
    <div className={styles.tabsContainer}>
      <ul className={styles.tabList} data-tutorial="tabs-list">
        {TABS.map(tab => (
          <li
            key={tab}
            className={`${styles.tabItem} ${tab === activeTab ? styles.activeTab : ''}`}
            onClick={() => setActiveTab(tab)}
            data-tutorial={`${tab.toLowerCase()}-tab`}
          >
            {tab}
          </li>
        ))}
      </ul>
      <div className={styles.tabContent}>{renderTabContent()}</div>
    </div>
  )
}
